// eslint-disable-next-line no-restricted-imports
import {
  Configuration,
  DefaultApiGetArticlesRequest,
  DefaultApiGetMarketNewsRequest,
  DefaultApiGetVideosRequest,
  DefaultApi as ErsteMarketGoApi,
} from '@eih-netbroker/api-erste-market-go';
import { AxiosInstance } from 'axios';
import { IConfigAPI } from '../config';
import { ResourceHeaders } from '../services/useResource';
import { BaseResource } from './base.resource';

export type MarketNewsRequest = Omit<DefaultApiGetMarketNewsRequest, 'acceptLanguage'>;
export type ArticlesRequest = Omit<DefaultApiGetArticlesRequest, 'acceptLanguage'>;
export type VideosRequest = Omit<DefaultApiGetVideosRequest, 'acceptLanguage'>;

export class ErsteMarketGoResource extends BaseResource {
  // Name has to be overridden, since the build job renames it to 'r' and
  // every resource class will have the same name
  // @ts-ignore
  public static name = 'ErsteMarketGoResource';

  private ersteMarketGoApi: ErsteMarketGoApi;

  constructor(axiosInstance: AxiosInstance, _basePath: string, configApi: IConfigAPI) {
    super(axiosInstance, configApi.ersteMarketGoUrl, configApi);
    this.ersteMarketGoApi = new ErsteMarketGoApi(new Configuration({}), configApi.ersteMarketGoUrl);
  }

  public async getMarketNews(request: MarketNewsRequest, headers: ResourceHeaders) {
    return this.ersteMarketGoApi.getMarketNews({ ...request, acceptLanguage: headers.acceptLanguage });
  }

  public async getArticles(request: ArticlesRequest, headers: ResourceHeaders) {
    return this.ersteMarketGoApi.getArticles({ ...request, acceptLanguage: headers.acceptLanguage });
  }

  public async getVideos(request: VideosRequest, headers: ResourceHeaders) {
    return this.ersteMarketGoApi.getVideos({ ...request, acceptLanguage: headers.acceptLanguage });
  }
}
